import React from "react";

//import { HeaderSection }  from './designcss/headercss';
import styled from 'styled-components';
//import headimage from './images/90.png';
//import headerwideimg from './images/hackhead.gif';

import SkillSection from "./components/skillsection";
import { CurrentBlogs } from "./blogs";

import MyCertificate from "./components/certificatepic";

import HeroSection from './herosection';

import PortfolioSections from './components/portfoliosection/PortfolioSections';

const Header = () => {

    return(
        <>
            <HeroSection/>
            <SkillSection />
            <PortfolioSections />
            <MyCertificate />
            <CurrentBlogs />
        </>
    );
}

export default Header;
